import { Award, Users, TrendingUp } from "lucide-react";
import marcolinoFernandes from "/src/assets/images/marcolino-fernandes.png";

export function About() {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <span className="text-brand-600 font-semibold mb-4 block">SOBRE O ESPECIALISTA</span>
                        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">Marcolino Fernandes</h2>
                        <p className="text-slate-600 mb-6 text-lg">
                            Especialista em marketing digital para clínicas e consultórios.
                            Já ajudou mais de 150 profissionais da saúde a transformarem suas
                            agendas vazias em máquinas de agendamento.
                        </p>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="text-center">
                                <Award className="w-8 h-8 text-brand-600 mx-auto mb-2" />
                                <p className="font-bold text-slate-900">+150</p>
                                <p className="text-sm text-slate-500">Clínicas atendidas</p>
                            </div>
                            <div className="text-center">
                                <Users className="w-8 h-8 text-brand-600 mx-auto mb-2" />
                                <p className="font-bold text-slate-900">+5M</p>
                                <p className="text-sm text-slate-500">Em investimento gerenciado</p>
                            </div>
                            <div className="text-center">
                                <TrendingUp className="w-8 h-8 text-brand-600 mx-auto mb-2" />
                                <p className="font-bold text-slate-900">500%</p>
                                <p className="text-sm text-slate-500">Aumento médio</p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-brand-100 rounded-2xl p-8 flex items-center justify-center h-[500px] overflow-hidden">
                        <img
                            src={marcolinoFernandes}
                            alt="Marcolino Fernandes - Especialista em marketing digital para clínicas"
                            className="h-full w-auto object-cover rounded-xl shadow-2xl"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
